import ButtonDropdown from "@rio-cloud/rio-uikit/ButtonDropdown"
import { MainRunUploadDialog, mainRunUploadMenuItem } from "./MainRunUploadMenuItem"
import { mainRunDownloadMenuItem } from "./MainRunDownloadMenuItem"
import * as React from "react"
import { useState } from "react"
import { useAssetsOfAccount } from "../../hooks/assets"
import { FormattedMessage } from "react-intl"
import { useGetCrossDocksQuery, useLazyGetMainRunsQuery } from "../../client/asn-matching/asnMatchingApi"
import moment from "moment-timezone"
import { saveAs } from "file-saver"
import Notification from "@rio-cloud/rio-uikit/Notification"
import { MainRunDataCsvWriter } from "../../helper/mainRunDataCsvTransformer"

export const MainRunButtonDropdown = (): React.ReactElement | null => {
    const [isLoading, setIsLoading] = useState(false)
    const [showUploadDialog, setShowUploadDialog] = useState(false)

    const crossDocksQuery = useGetCrossDocksQuery()
    const assets = useAssetsOfAccount()
    const [triggerGetMainRuns] = useLazyGetMainRunsQuery()

    if (crossDocksQuery.isLoading || crossDocksQuery.error || crossDocksQuery.data === undefined || crossDocksQuery.data.length === 0) {
        return null
    }

    const crossDocks = crossDocksQuery.data

    const downloadMainRuns = (): void => {
        const csvWriter = new MainRunDataCsvWriter(() => "")
        setIsLoading(true)
        const fileName = `mainRuns_${moment().format("YYYY-MM-DD_HHmm")}.csv`
        const triggerGetMainRuns1 = triggerGetMainRuns()
        triggerGetMainRuns1.unwrap()
            .then(response => {
                const csv = csvWriter.unparseMainRunDataCsv(response, assets, crossDocks)
                saveAs(new Blob([csv], { type: "text/csv" }), fileName)
            })
            .catch(() => {
                Notification.error(<FormattedMessage id={"mainRun.download.error"}/>)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }

    return <>
        <ButtonDropdown
            disabled={isLoading}
            title={<>
                <span className="uikit-icon icon-document-out margin-right-5"/>
                <FormattedMessage id={"mainRun.dropdown.title"}/>
            </>}
            items={[
                mainRunUploadMenuItem(() => setShowUploadDialog(true)),
                mainRunDownloadMenuItem(downloadMainRuns),
            ]}
        />
        <MainRunUploadDialog 
            assets={assets} 
            crossDocks={crossDocks} 
            showDialog={showUploadDialog} 
            closeDialog={(): void => setShowUploadDialog(false)}
        />
    </>
}